<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    export let value:boolean = false;
    export let label:string = '';


    const dispatch = createEventDispatcher();

    const change = () => {
        value = !value
        dispatch('change', value);
    }
</script>
<div class="flex items-center gap-2">
    <button on:click={change} type="button" class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2" role="switch" aria-checked="{value}">
        <span class="sr-only">{label}</span>
        <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md bg-white"></span>
        <!-- Enabled: "bg-indigo-600", Not Enabled: "bg-gray-200" -->
        <span aria-hidden="true" class="{value? 'bg-primary-600' : 'bg-gray-200'} pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"></span>
        <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
        <span aria-hidden="true" class="{value? 'translate-x-5' : 'translate-x-0'} translate-x-0 pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"></span>
    </button>
    <span on:keydown={change} on:click={change}>{label}</span>
</div>
